//Modules
import React, { useContext } from "react"
import { Link } from "gatsby"
//Styles
import styled from "styled-components"
import { font, colors, spacing, flex, boxShadow } from "../../../Utilities"
//Constants
import { menu, classroomManagement } from "../../../constants/menu"
//Context
import { UserContext } from "../../../context/context"
//Auth
import firebase from "../../../auth/firebase"

const NavMenu = () => {
  const auth = useContext(UserContext)
  const { loggedIn, logout } = auth

  return (
    <StyledNavMenu>
      <div className="dropdown-button">
        <p className="menu-item">Classroom Management ></p>
        <div className="dropdown">
          {classroomManagement.map((link, i) => {
            return (
              <Link to={link.path} key={i} className="link">
                {link.name}
              </Link>
            )
          })}
        </div>
      </div>

      {menu.map((menuItem, i) => {
        return (
          <Link
            key={i}
            to={menuItem.path}
            className="menu-item"
            activeClassName="active-link"
          >
            {menuItem.name}
          </Link>
        )
      })}
      {!loggedIn ? (
        <Link
          to="/protected/login"
          className="menu-item"
          activeClassName="active-link"
        >
          Login
        </Link>
      ) : (
        <button
          className="menu-item"
          onClick={() => {
            firebase
              .auth()
              .signOut()
              .then(() => {
                logout()
              })
              .catch(err => {
                console.log(err)
              })
          }}
        >
          Logout
        </button>
      )}
    </StyledNavMenu>
  )
}

const StyledNavMenu = styled.nav`
  display: none;
  margin-left: auto;
  margin-right: ${spacing.S};

  @media (min-width: 1200px) {
    ${flex("row", "flex-end", "center")};
  }

  .dropdown-button {
    position: relative;

    .dropdown {
      ${flex("column", "flex-start", "flex-start")};
      position: absolute;
      width: 35rem;
      right: -3rem;
      bottom: -15rem;
      background: white;
      box-shadow: ${boxShadow.dark};
      padding: ${spacing.S};
      opacity: 0;
      transition: 0.4s;
      visibility: none;
      z-index: 10000;
      border-radius: 5px;

      .link {
        ${font("S")};
        margin-bottom: ${spacing.S};
        transition: 0.4s;

        &:hover {
          color: ${colors.primaryDD};
        }
      }
    }

    &:hover {
      .dropdown {
        opacity: 1;
        visibility: visible;
      }
    }
  }

  .menu-item {
    ${font("S")};
    ${flex("row", "flex-start", "center")};
    margin-right: ${spacing.S};
    cursor: pointer;
    transition: 0.5s;
    padding: 0;
    text-align: center;

    &:hover {
      color: ${colors.primaryDD};
    }

    @media (min-width: 1100px) {
      margin-right: ${spacing.M};
      ${font("SSM")};
    }
  }
`

export default NavMenu
